import { render, staticRenderFns } from "./AuthorisationsPage.vue?vue&type=template&id=59b9dfee&scoped=true&"
import script from "./AuthorisationsPage.vue?vue&type=script&lang=js&"
export * from "./AuthorisationsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b9dfee",
  null
  
)

export default component.exports